import type { OrbState } from '@/registry/lib/orb-state'

export type AuraPair = { from: string; to: string }

/** Soft ink / creme — default / idle on the dark stage. */
export const LOSI_AURA_FROM = '#6b8cae'
export const LOSI_AURA_TO = '#c4b8a8'

/**
 * Dark stage: soft bands on black / near-black paper.
 * Cross cool↔warm inside each pair (idle's ink→creme) — same-hue ends look flat.
 */
const AURA_SOMBRE: Record<OrbState, AuraPair> = {
  idle: { from: LOSI_AURA_FROM, to: LOSI_AURA_TO },
  connecting: { from: '#5a7fa6', to: '#c4b8a8' },
  // steel → warm creme (cool-led)
  listening: { from: '#5a7fa6', to: '#c4b8a8' },
  // lilac → dusty rose
  thinking: { from: '#7a6b9a', to: '#c4a8b0' },
  // amber → cool mist (warm-led)
  speaking: { from: '#c4a574', to: '#9eb6c9' },
  error: { from: '#fb7185', to: '#f43f5e' },
  disabled: { from: '#6b6f78', to: '#9a9ea6' }
}

/**
 * Light stage: split hues (not just darkened sombre ends) so rings stay
 * multicolor on white paper.
 */
const AURA_CLAIR: Record<OrbState, AuraPair> = {
  idle: { from: '#3d6a8a', to: '#b8956a' },
  connecting: { from: '#3d6a8a', to: '#7a9eb8' },
  listening: { from: '#2a5f8c', to: '#5a9a9e' },
  thinking: { from: '#5a4580', to: '#a87890' },
  speaking: { from: '#b06a38', to: '#c9a45a' },
  error: { from: '#d63c34', to: '#e8a0a8' },
  disabled: { from: '#5a6270', to: '#9a8f82' }
}

/** Per-state Aura Field colours. `clair` = light UI theme. */
export function realtimeAuraColors(
  state: OrbState,
  clair = false
): AuraPair {
  return (clair ? AURA_CLAIR : AURA_SOMBRE)[state]
}
